import { Link } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import { Table } from 'react-bootstrap';
import { useEffect, useState } from "react";
import axios from "axios";
// import UserContext from '../UserContext';
import Cookies from 'js-cookie'
// import data from '../../public/db.json'
import noDataImage from '../assets/images/empty-box.png'
export default function DoctorDashboard() {
    const [userData,setUserData] =useState({})
    const [appointmentList, setAppointmentList] = useState([])
    const [newAppointment, setNewAppointment] = useState(0)
    const fetchAppt = () => {
        axios.get('https://684e67d4f0c9c9848d280f2a.mockapi.io/patientlist')
            .then(res => {
                console.log(res.data)
                setAppointmentList(res.data)
                res.data.map((item) => {
                    if (item.patientType == 'new') {
                        setNewAppointment(newAppointment + 1)
                    }
                })
                   
            })
            .catch(err => {
                console.log(err)
            })
    }
    const getNewPatientCount = ()=>{
      let newAppointmentArray =  appointmentList.filter(item => item.patientType === 'new')
        return newAppointmentArray.length
    }
    useEffect(() => {
         let cookieuserData = Cookies.get("userData")
         if(cookieuserData){
            setUserData(JSON.parse(cookieuserData))
         }
            
        fetchAppt();
    }, [])
    return (
        <div className="doctor-dashboard-page">
            <Container>
                <div className="doctor-banner">
                    <p className="greeting-text">Good Morning,</p>
                    <h1 className="doctorName">Dr. {userData.name} <small>MBBS, MD</small></h1>
                    <p className="doctor-schedule">your Schedule today</p>
                    <Link to="./profile" className="btn btn-light my-setting-btn">My Settings</Link>
                    <div className="appointment-info">
                        <div className="info-block">
                            <span className="count">{appointmentList.length}</span>
                            <span className="count-type">Appointments</span>
                        </div>
                        <div className="info-block">
                            <span className="count">{getNewPatientCount()}</span>
                            <span className="count-type">New Patients</span>
                        </div>
                        <div className="info-block">
                            <span className="count">{appointmentList.length - getNewPatientCount()}</span>
                            <span className="count-type">Old Patients</span>
                        </div>
                    </div>
                </div>
                <div className="appointment-block">
                    <h5>Appointments</h5>
                    <div className="appoitmrnt-details">

                        {
                            appointmentList.length > 0 ?
                             <Table responsive="sm" className="appointment-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Patient Name</th>
                                    <th>Age</th>
                                    <th>Gender</th>
                                    <th>Depertment</th>
                                    <th>Dieases</th>
                                    <th>Date</th>
                                    <th>Time</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    appointmentList.map((appoints, index) => {
                                       
                                        return (
                                            <tr key={appoints.id}>
                                                <td>{index + 1}</td>
                                                <td className="text-capitalize" data-content="Name - ">{appoints.name}
                                                    {
                                                        appoints.patientType === 'new' && <strong className="text-danger small ms-2">New</strong>
                                                    }
                                                </td>
                                                <td data-content="Age - ">{appoints.age}</td>
                                                <td className="text-capitalize" data-content="Gender - ">{appoints.gender}</td>
                                                <td className="text-capitalize" data-content="Depertment - ">{appoints.depertment}</td>
                                                <td className="text-capitalize" data-content="Diseas - ">{appoints.diseas}</td>
                                                <td data-content="App. Date - ">{appoints.date}</td>
                                                <td data-content="App. Time - ">{appoints.time}</td>
                                                <td><Link className="btn btn-outline-info btn-sm" to={`/patient-information/${appoints.id}`}>View Patient Details</Link></td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </Table>
                        :
                        <div className="text-center pt-3">
                        <img src={noDataImage} alt="no data" style={{width : 120}}/>
                        <p className="text-danger">No Appointments Today</p>
                        </div>
                        }
                       
                    </div>
                </div>
            </Container>
        </div>
    )

}